import { render, staticRenderFns } from "./SmartTablePagination.vue?vue&type=template&id=930c475a&scoped=true"
import script from "./SmartTablePagination.vue?vue&type=script&lang=js"
export * from "./SmartTablePagination.vue?vue&type=script&lang=js"
import style0 from "./SmartTablePagination.vue?vue&type=style&index=0&id=930c475a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930c475a",
  null
  
)

export default component.exports